import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { RootState } from 'types'

export const useAuth = () => useSelector(({ auth }: RootState) => auth, isEqual)
